"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioInputState = void 0;
const input_state_1 = require("./input.state");
class RadioInputState extends input_state_1.InputState {
    constructor(label, group) {
        super(label);
        this.group = group;
        if (RadioInputState.inputGroups[group] == null) {
            RadioInputState.inputGroups[group] = [this];
        }
        else {
            RadioInputState.inputGroups[group].push(this);
        }
    }
    setValue(val) {
        super.setValue(val);
        if (val) {
            const inputs = RadioInputState.inputGroups[this.group];
            for (const input of inputs) {
                if (input !== this) {
                    input.setValue(false);
                }
            }
        }
    }
}
exports.RadioInputState = RadioInputState;
RadioInputState.inputGroups = {};
//# sourceMappingURL=radio.input.state.js.map